import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";

import EnhancferList from "../EnhancferList";
import * as actions from "../../../store/actions";
import * as appsyncOperations from "../../../utils/appsyncOperations";
import diffArrays from "../../../utils/diffArrays";
import findDivisionRelations from "../../../utils/findDivisionRelations";

const UserDivisionTransfer = ({
  open,
  onClose,
  userId,
  serviceProviderId,
  displayName,
  divisionsById,
  userDivisionIds,
  everyOtherDivisionId,
  dispatch,
  enqueueSnackbar,
}) => {
  const [renderEnhancfer, setRenderEnhancfer] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (open) {
      setRenderEnhancfer(true);
    }
  }, [open]);

  const saveChanges = async ({ right: nextUserDivisionIds }) => {
    setLoading(true);
    const batchUpdateInput = [];
    const difference = diffArrays(userDivisionIds, nextUserDivisionIds);
    for (const divisionId of difference.remove) {
      batchUpdateInput.push({
        divisionId,
        relationalId: userId,
        operation: "DELETE",
        variant: "USER",
        serviceProviderId,
      });
    }
    for (const divisionId of difference.add) {
      batchUpdateInput.push({
        divisionId,
        relationalId: userId,
        operation: "CREATE",
        variant: "USER",
        serviceProviderId,
      });
    }
    try {
      const updatedDivisionRelations = await appsyncOperations.batchWriteDivisionRelations(
        batchUpdateInput
      );
      dispatch(
        actions.divisions.setDivisions({
          divisionRelations: updatedDivisionRelations,
        })
      );
      onClose();
      setLoading(false);
      enqueueSnackbar("Update successful!", { variant: "success" });
    } catch (error) {
      setLoading(false);
      enqueueSnackbar(error, { variant: "error" });
    }
  };

  // EnhancferList is conditionally rendered so that its state will reset whenever the dialog is closed.
  return (
    renderEnhancfer && (
      <EnhancferList
        title={`Select divisions ${displayName ? `\u2022 ${displayName}` : ""}`}
        isOpen={open}
        onClose={onClose}
        onExited={() => setRenderEnhancfer(false)}
        data={divisionsById}
        leftLabel="Available divisions"
        initLeft={everyOtherDivisionId}
        rightLabel="Selected divisions"
        initRight={userDivisionIds}
        valueExtractor={(item) => item.displayName}
        searchKeys={["displayName"]}
        searchId="divisionId"
        loading={loading}
        onSaveHandler={saveChanges}
      />
    )
  );
};

const mapStateToProps = (state, ownProps) => {
  const userDivisions = findDivisionRelations(ownProps.userId);
  const user = state.users.byId[ownProps.userId];
  return {
    serviceProviderId: state.auth.user.attributes["custom:service_provider_id"],
    displayName: user !== undefined ? user.displayName : null,
    divisionsById: state.divisions.byId,
    userDivisionIds: Object.keys(userDivisions.included).filter(
      (divisionId) => !state.divisions.byId[divisionId].isDeleted
    ),
    everyOtherDivisionId: Object.keys(userDivisions.excluded).filter(
      (divisionId) => !state.divisions.byId[divisionId].isDeleted
    ),
  };
};
export default withSnackbar(connect(mapStateToProps)(UserDivisionTransfer));
